import { BlurPopUpByWord } from "../animations/PopUpAnimations";
import PiccadillyImage from "@/assets/projects/Piccadilly.png";
import AgoniusImage from "@/assets/projects/Agonius.png";
import B2boxImage from "@/assets/projects/B2box.png";
import ProjectCard from "./ProjectCard";
import { MotionDiv } from "../animations/MotionDivWrapper";

const ProjectData = [
  {
    name: "Piccadilly",
    desc: "A storefront for a U.S. based restaurant chain with 40+ outlets, supporting dine-in, group dining, catering, and family dining services.",
    tech: ["Next.js", "Vendure", "GraphQL", "Zustand", "GoogleMapsApi"],
    link: "https://www.piccadilly.com/",
    image: PiccadillyImage,
  },
  {
    name: "Agonius",
    desc: "A digital funding‑platform that helps companies and startups quickly find the right grant programmes and guide them through the application process to increase their chances of financial support.",
    tech: ["React.js", "AWS", "Jotai", "Stripe"],
    link: "https://www.app.agonius.de/",
    image: AgoniusImage,
  },
  {
    name: "B2box",
    desc: "A B2b e-commerce platform that connects importers with wholesalers and retailers in different countries.",
    tech: [
      "Remix.js",
      "React.js",
      "Vendure",
      "GraphQL",
      "Jotai",
      "Stripe",
      "NestJS",
    ],
    link: "https://b2-box.com/",
    image: B2boxImage,
  },
];

const Projects = () => {
  return (
    <div id="projects" className="border-t border-white/10">
      <div className="container w-full mx-auto pt-12 lg:pt-20">
        <h2 className="text-center text-4xl uppercase">
          <BlurPopUpByWord text=" Projects" />
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 items-center justify-between w-full mt-10">
          {ProjectData.map((project, index) => (
            <MotionDiv direction="up" delay={0.4 * index} key={project.name}>
              <ProjectCard project={project} />
            </MotionDiv>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
